
import React, { useState, useEffect, lazy, Suspense } from "react";
import { cn } from "@/lib/utils";

interface RichTextEditorProps {
  className?: string;
  onChange?: (html: string) => void;
  dir?: "ltr" | "rtl";
  value?: string;
}

// Import TipTap editor directly rather than using lazy loading
// This ensures we always have the same editor experience
const TipTapEditor = lazy(() => import('@/components/editor/TipTapEditor'));

const RichTextEditor = React.memo(React.forwardRef<HTMLDivElement, RichTextEditorProps>(
  ({ className, onChange, value, dir = "ltr" }, ref) => {
    const [isClient, setIsClient] = useState(false);
    
    useEffect(() => {
      console.log("Initializing RichTextEditor");
      setIsClient(true);
    }, []);

    // Only render on client-side to avoid hydration issues
    if (!isClient) {
      return (
        <div className={cn("border rounded-md", className)} ref={ref}>
          <div className="flex items-center justify-center h-[150px]">
            <p className="text-sm text-gray-500">Loading editor...</p>
          </div>
        </div>
      );
    }

    return (
      <div 
        className={cn("rich-text-editor-container border rounded-md overflow-hidden", className)} 
        ref={ref}
        dir={dir}
      >
        <Suspense fallback={
          <div className="flex items-center justify-center h-[150px]">
            <p className="text-sm text-gray-500">Cargando editor...</p>
          </div>
        }>
          <TipTapEditor
            onChange={onChange}
            value={value}
            dir={dir}
          />
        </Suspense>
      </div>
    );
  }
));

RichTextEditor.displayName = "RichTextEditor";

export { RichTextEditor };
